import {alias, createModelSchema} from "serializr";
import {BaseObject} from "@/common/BaseObject";

import {Range} from "../utils/Range";
import {Schema} from "@/common/Schema";

export class AdRefillModel extends BaseObject {

    constructor() {
        super();

        this._levelRange = null;
        this._energyRefill = 0;
    }

    get levelRange() {
        return this._levelRange;
    }

    set levelRange(value) {
        this._levelRange = value;
    }

    get energyRefill() {
        return this._energyRefill;
    }

    set energyRefill(value) {
        this._energyRefill = value;
    }

    valid() {
        if (this.levelRange && !this.levelRange.valid()) {
            return false;
        }

        if (String(this.energyRefill).trim() === '' || isNaN(this.energyRefill)) {
            return false;
        }

        return true;
    }

    copy() {
        let value = super.copy();
        value._enabled = false;
        return value;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new AdRefillModel());
        } else if (target instanceof AdRefillModel) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(AdRefillModel, {
    _levelRange: alias("level-range", Range.schema()),
    _energyRefill: alias("energy-refill", Schema.primitive()),
});